type WaitForPopupMessageParams<T> = {
  allowedOrigin: string;
  isSource: (source: MessageEventSource | null) => boolean;
  validate: (data: unknown) => data is T;
  signal: AbortSignal;
};

export function waitForPopupMessage<T>({
  allowedOrigin,
  isSource,
  validate,
  signal,
}: WaitForPopupMessageParams<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (signal.aborted) {
      reject(signal.reason);

      return;
    }

    const cleanup = () => {
      window.removeEventListener('message', handler);
      signal.removeEventListener('abort', onAbort);
    };

    const handler = (event: MessageEvent) => {
      if (event.origin !== allowedOrigin) {
        return;
      }

      if (!isSource(event.source)) {
        return;
      }

      if (!validate(event.data)) {
        return;
      }

      cleanup();
      resolve(event.data);
    };

    const onAbort = () => {
      cleanup();
      reject(signal.reason);
    };

    window.addEventListener('message', handler);
    signal.addEventListener('abort', onAbort, { once: true });
  });
}
